import React from 'react';
import './spinner.css';

const spinner = ({ message = 'Cargando resultados...'}) => {
  return (
    <div className="spinner-container">
      <div className="spinner-loader"></div>
      <div className="spinner-text">{message}</div>
    </div>
  );
};

export default spinner;
